import { IRootState } from "app/model"
import { Chart as ChartJS } from "chart.js/auto"
import React from "react"
import { connect } from "react-redux"
import { IChartDataSet } from "ui/configuration/model"
import { createChart, updateChart } from "ui/configuration/tools/chart"
import { isPhoneScreen } from "ui/tools/responsive"

interface IChartConnectProps {
  isPhone: boolean
}

interface IChartProps {
  type: "line" | "bar"
  divId: string
  dataSets: IChartDataSet[]
}

const ChartFn = React.memo(({ type, divId, dataSets, isPhone }: IChartProps & IChartConnectProps) => {
  const [chart, setChart] = React.useState<null | ChartJS>(null)
  React.useEffect(() => {
    if (!chart) {
      setChart(createChart(type, divId, dataSets, isPhone))
    } else {
      setChart(updateChart(chart, dataSets))
    }
  }, [dataSets])
  return <canvas id={divId} style={{ width: "100%" }} />
})

export const Chart = connect(
  (state: IRootState): IChartConnectProps => ({
    isPhone: isPhoneScreen(state)
  })
)(ChartFn)
